/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import classNames from 'classnames';
import { get, isEmpty } from 'lodash';

import { COMPANY_NAME_INPUT } from '../../../constants';
import Input, { CleanHTMLInputPropsType, IInputProps } from '../input';

import './input-select.scss';

type ISelectInputProps = IInputProps & {
  selectData?: Record<string, string>;
  onSelect?: () => void;
  isSelectVisible: boolean;
};

const InputSelect = React.forwardRef<
  HTMLInputElement,
  ISelectInputProps & CleanHTMLInputPropsType
>(({ selectData, onSelect, isSelectVisible, className = '', ...rest }, ref) => {
  const handleSelectionClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onSelect && onSelect();
  };

  return (
    <div className="input-select">
      <Input
        {...{ ...rest, ref }}
        className={classNames('input-select__input', {
          [className]: className,
        })}
      />
      {selectData && !isEmpty(selectData) && isSelectVisible && (
        <div className="input-select__dropdown" onClick={handleSelectionClick}>
          {get(selectData, `${COMPANY_NAME_INPUT}`, '')}
        </div>
      )}
    </div>
  );
});

export default InputSelect;
